import type {
  AlertItem,
  CdewContent,
  FooterInfo,
  HeroContent,
  HomeNewsItem,
  QuickLink,
  SeductionContent,
  Spotlight,
} from '../types/content'

/**
 * Visuels de la maquette. La médiathèque publique de la Ville ne contient que des
 * archives et des PDF : ces images sont des placeholders, à remplacer par les
 * photos officielles avant toute présentation.
 */
const IMG_VUE = 'https://cdn.magicpatterns.com/uploads/1yAYBg9biiKgNX2nhCXPNk/image.png'
const IMG_RIVIERE = 'https://cdn.magicpatterns.com/patterns/generated-images/5fd42455-d112-4234-8bf8-10181a8b6838.jpg'
const IMG_PARC = 'https://cdn.magicpatterns.com/patterns/generated-images/81733988-614c-4ea1-a92b-4d6bdcb10469.jpg'

export const hero: HeroContent = {
  script: 'L’accueillante',
  image: IMG_VUE,
}

/** La barre de services bciti+, seule rangée ajoutée sous le hero. */
export const quickLinks: QuickLink[] = [
  { label: 'Mon espace', icon: 'smartphone', to: '/mon-espace' },
  { label: 'Inscriptions et réservations', icon: 'ball', to: '/mes-loisirs' },
  { label: 'Requêtes et signalements', icon: 'alert', to: '/mes-demandes' },
  { label: 'Collectes', icon: 'trash', to: '/mes-collectes' },
  { label: 'Médailles animaux', icon: 'pet', to: '/mes-animaux' },
  { label: 'Demande de permis', icon: 'permit' },
  { label: 'Avis publics', icon: 'bell', to: '/notifications' },
]

export const heroPrompts: { label: string; to: string }[] = [
  { label: 'Ma prochaine collecte', to: '/mes-collectes' },
  { label: 'Signaler un bris', to: '/mes-demandes' },
  { label: 'Inscrire mon enfant', to: '/mes-loisirs' },
]

export const alert: AlertItem = {
  level: 'info',
  title: 'Collecte des gros rebuts — vendredi 2 octobre',
  detail: 'Dernière des trois collectes de 2026.',
  body: [
    'Les gros rebuts sont ramassés trois vendredis en 2026 : le 1er mai, le 3 juillet et le 2 octobre.',
    'Les bacs et les encombrants doivent être mis en bordure de rue à partir de 17 h la veille de la collecte, et retirés de la rue avant 20 h le jour même.',
  ],
  scope: 'Collecte des gros rebuts · vendredi 2 octobre 2026',
}

export const spotlight: Spotlight = {
  eyebrow: 'À ne pas manquer',
  title: 'Les journées de la culture 2026',
  teaser:
    'Le samedi 26 septembre 2026, de 10 h à 17 h, au Parc historique de la Poudrière. Une journée gratuite pour célébrer notre histoire, notre créativité et notre communauté.',
  cta: 'Voir le calendrier',
  poster: IMG_PARC,
  highlights: [
    'Prestations musicales',
    'Visite guidée avec capsules audio',
    'Poterie et métiers d’arts',
    'Livres à donner',
    'Exposition sur l’histoire de Windsor',
    'Concours de dessin sur signet',
  ],
}

export const news: HomeNewsItem[] = [
  {
    id: 'programmation-automne',
    day: '17',
    month: 'août',
    year: '2026',
    title: 'Programmation des loisirs – Automne 2026 : les inscriptions débutent le 24 août!',
    excerpt:
      'Bouger, apprendre, créer ou simplement essayer quelque chose de nouveau : la programmation Activités & Loisirs – Automne 2026 propose une foule d’occasions de rester actif et de se divertir',
  },
  {
    id: 'windsor-mills',
    day: '07',
    month: 'août',
    year: '2026',
    title:
      'Windsor Mills à l’aube de la modernité : quand l’eau, l’électricité et les règlements transforment une ville (1898-1900)',
    excerpt:
      'À la fin du XIXe siècle, Windsor Mills connaît une transformation silencieuse mais fondamentale. En quelques années seulement, le petit noyau industriel des Cantons-de-l’Est passe d’une organisation villageoise relativement simple',
  },
]

export const usefulLinks: { label: string; to?: string }[] = [
  { label: 'Services numériques', to: '/mon-espace' },
  { label: 'Espace citoyen', to: '/mon-espace' },
  { label: 'Demande de permis' },
  { label: 'Info-Travaux' },
  { label: 'Règlements municipaux' },
]

export const seduction: SeductionContent = {
  script: 'L’accueillante',
  title: 'Ville de cœur, laissez-vous séduire par la Ville de Windsor.',
  images: [IMG_RIVIERE, IMG_PARC, IMG_VUE],
}

export const cdew: CdewContent = {
  title: 'Comité de Développement Économique (CDÉW)',
  body:
    'Le Comité de Développement Économique de Windsor (CDÉW) assure la mise en marché et le bon développement résidentiel, commercial et industriel. Responsable du Parc industriel de la 55, le Comité accompagne également toutes les entreprises du territoire dans leurs projets d’implantation, de relocalisation et de croissance.',
  cta: 'En savoir plus',
  image: IMG_RIVIERE,
}

export const footerInfo: FooterInfo = {
  links: [
    'Contact',
    'Offres d’emploi',
    'Comité de développement économique de Windsor',
    'Politique de témoins (CA)',
  ],
  copyright: 'Tous droits réservés © 2021 – Ville de Windsor',
  address: ['11, rue Saint-Georges, Local 230', 'C.P. 90, Windsor (Québec) J1S 2L7'],
  phone: '(819) 845-7888',
  fax: '(819) 845-7606',
  email: 'info@villedewindsor.qc.ca',
  hours: ['Lundi au jeudi : 8 h à 12 h et 12 h 45 à 16 h 30', 'Vendredi : 8 h à 12 h'],
}
